export default __webpack_public_path__ + "static/media/copy.a7546147.svg";